import { Controller } from "@hotwired/stimulus";
import debounce from "../../utils/debounce";

export default class extends Controller {
  static targets = [
    "product",
    "value",
    "searchInput",
    "virtualizedList",
    "selectAllInput"
  ];

  selectedItems = {};
  virtualizedList;
  products = [];
  excludedProducts = {};

  initialize() {
    this.search = debounce(this.search.bind(this), 300);
  }

  connect() {
    this.search();
  }

  productTargetConnected(input) {
    if (this.selectedItems[input.value]) {
      input.checked = true;
    }
  }

  setExcludedProducts(excludedProducts) {
    console.log("setExcludedProducts");
    this.excludedProducts = excludedProducts;
    const inputName = "q[id_not_in][]";
    this.element
      .querySelectorAll(`[name="${inputName}"]`)
      .forEach((input) => input.remove());
    Object.keys(excludedProducts).forEach((productId) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = inputName;
      input.value = productId;
      this.element.appendChild(input);
    });
  }

  toggleItem({ target: input }) {
    const product = this.inputProduct(input);
    if (this.selectedItems[product.id]) {
      delete this.selectedItems[product.id];
    } else {
      this.selectedItems[product.id] = product;
    }

    const selectedTotal = Object.keys(this.selectedItems).length;
    if (selectedTotal === 0) {
      this.selectAllInputTarget.checked = false;
      this.selectAllInputTarget.removeAttribute("partial");
    } else if (selectedTotal === this.virtualizedListTarget.childNodes.length) {
      this.selectAllInputTarget.checked = true;
      this.selectAllInputTarget.removeAttribute("partial");
    } else {
      this.selectAllInputTarget.checked = true;
      this.selectAllInputTarget.setAttribute("partial", true);
    }
  }

  inputProduct(input) {
    return (input.product = input.product ?? JSON.parse(input.dataset.product));
  }

  search() {
    fetch(this.element.action, {
      method: "post",
      body: new FormData(this.element)
    })
      .then((response) => response.json())
      .then(({ entries: products }) => {
        this.virtualizedListTarget.innerHTML = products;
      });
  }

  toggleAll({ target: { checked } }) {
    this.selectAllInputTarget.removeAttribute("partial");
    if (checked) {
      this.virtualizedListTarget
        .querySelectorAll("input[type=checkbox]:not(:checked)")
        .forEach((checkbox) => {
          checkbox.checked = true;
          const product = this.inputProduct(checkbox);
          this.selectedItems[product.id] = product;
        });
    } else {
      this.virtualizedListTarget
        .querySelectorAll("input[type=checkbox]:checked")
        .forEach((checkbox) => {
          checkbox.checked = false;
          this.selectedItems = {};
        });
    }
  }

  submit() {
    if (this.isValid()) {
      this.dispatch("add", {
        detail: {
          selectedItems: this.selectedItems,
          value: this.valueTarget.value
        }
      });
    }
  }

  isValid() {
    return this.valueTarget.value && Object.keys(this.selectedItems).length > 0;
  }
}
